import React from 'react';
import { alpha, Box, Typography, useTheme } from '@mui/material';
import FlexBetween from './FlexBetween';

const StatBox = ({
  className = '',
  title,
  value,
  increase,
  icon,
  description,
  color,
  onClick,
}) => {
  const theme = useTheme();
  return (
    <Box
      onClick={onClick}
      className={className}
      gridColumn='span 2'
      gridRow='span 1'
      display='flex'
      flexDirection='column'
      justifyContent='space-between'
      p='1.25rem 1rem'
      flex='1 1 100%'
      borderRadius='0.55rem'
      sx={{
        backdropFilter: 'blur(5px)',
        boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.1)',
        backgroundColor: alpha(color, 0.6),
        border: '1px solid rgba(0, 0, 0, 0.1)',
        minHeight: '5rem',
        minWidth: '13rem',
      }}
    >
      <FlexBetween>
        <Typography
          variant='h6'
          sx={{
            color: theme.palette.secondary[50],
          }}
        >
          {title}
        </Typography>

        {icon}
      </FlexBetween>

      <Typography
        variant='h3'
        fontWeight='600'
        sx={{
          color: theme.palette.secondary[50],
        }}
      >
        {value}
      </Typography>
      <FlexBetween gap='1rem'>
        <Typography
          variant='h5'
          fontStyle='italic'
          sx={{
            color: theme.palette.secondary[50],
          }}
        >
          {increase}
        </Typography>
        <Typography>{description}</Typography>
      </FlexBetween>
    </Box>
  );
};

export default StatBox;
